(function($) {
    $(document).on('facetwp-loaded', function() {

      var choices = FWP.settings.num_choices;
      let totals = 0;

      console.log(FWP.settings);

      for (key in choices) {
        var $facet = $('.facetwp-facet-' + key);
        var facet_label = FWP.settings.labels[key];
        if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
              $facet.wrap('<div class="facet-wrap"></div>');
              $facet.before('<h3 class="facet-label">' + facet_label + '</h3>');
        }
        $facetparent = $facet.closest('.facet-wrap');
        totals += choices[key];
        if (0 === choices[key]) {
          $facetparent.hide();
        } else {
          $facetparent.show();
          //var facet_label = FWP.settings.labels[key];
          //if ($parent.closest('.facet-wrap').length < 1 && $parent.closest('.facetwp-flyout').length < 1) {
              //$parent.wrap('<div class="facet-wrap"></div>');
              //$parent.before('<h3 class="facet-label">' + facet_label + '</h3>');
          //}
        };
      }

      //console.log('totals');
      //console.log(totals);

      if (totals === 0) {
        // we don't have any facets, hide this widget
        $( "aside" ).each(function( index ) {
          let filteraside = $(this).find('.widget-title').is(':contains("Filters")');
          if (filteraside === true) {
            //$(this).hide();
          }
        });
      }

    });
})(jQuery);
